import { API } from 'core/api';
import Axios from 'axios';

class ActivityTimelineService {
  private _api: string;

  constructor(incidentId: string) {
    this._api = `${API.config.batman}/organizations/${API.config.organizationId}/incidents/${incidentId}/timeline/manual`;
  }
  public addManualActivityInTimeline = (
    content: string,
    timeStamp: string,
    showInPostmortem: boolean,
  ) => {
    return Axios.post(`${this._api}/add`, {
      content,
      timestamp: timeStamp,
      should_show_in_postmortem: showInPostmortem,
    });
  };

  public deleteEntryInActivityTimeline = (logId: string) => {
    return Axios.delete(`${this._api}/delete/${logId}`);
  };

  public updateEntryInActivityTimeline = (
    logId: string,
    content: string,
    timeStamp: string,
    showInPostmortem: boolean,
  ) => {
    return Axios.put(`${this._api}/update/${logId}`, {
      content,
      timestamp: timeStamp,
      should_show_in_postmortem: showInPostmortem,
    });
  };
}

export default ActivityTimelineService;
